import type { SlugData } from '../slug-data';

/** Canonical mock {@link SlugData}. */
export const MOCK_SLUG_DATA: SlugData = {
  id: 1,
  name: 'Metal Cutting',
  slug: 'metal-cutting',
};

/** Builds a {@link SlugData} from {@link MOCK_SLUG_DATA} with overrides. */
export function createMockSlugData(overrides?: Partial<SlugData>): SlugData {
  return { ...MOCK_SLUG_DATA, ...overrides };
}

/**
 * Builds a list of mock {@link SlugData} entries. IDs are auto-incremented
 * from `1` and names default to `Item N`.
 */
export function createMockSlugDataList(
  count = 3,
  overrideAt?: (index: number) => Partial<SlugData>
): SlugData[] {
  return Array.from({ length: count }, (_, i) => {
    const overrides = overrideAt?.(i);
    return createMockSlugData({
      id: i + 1,
      name: `Item ${i + 1}`,
      slug: `item-${i + 1}`,
      ...overrides,
    });
  });
}
